import React from "react";
import { Box, Button, Container, Typography, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import Seo from "./Seo";

/**
 * Unknown paths previously rendered an empty band between the nav and the footer,
 * because nginx serves index.html for everything and no route matched.
 */
const NotFound = () => {
  const theme = useTheme();

  return (
    <Box
      p={4}
      sx={{
        backgroundColor: theme.palette.background.default,
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "300px",
      }}
    >
      <Seo
        route="/404"
        title="Page not found | BadgeReg"
        description="That page does not exist. Browse BadgeReg pricing, FAQs, or try the live merit badge college demo."
        noindex
      />
      <Container sx={{ textAlign: "center" }}>
        <img
          src="/badges/Orienteering.svg"
          alt=""
          aria-hidden="true"
          height={70}
        />
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ color: theme.palette.text.primary, fontWeight: "bold", pt: 2 }}
        >
          We could not find that page
        </Typography>
        <Typography
          variant="subtitle1"
          component="p"
          sx={{ color: theme.palette.text.secondary, pb: 3 }}
        >
          The link may be out of date. Everything on BadgeReg is a click away
          from here.
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Button variant="contained" component={RouterLink} to="/">
            Back to home
          </Button>
          <Button variant="outlined" component={RouterLink} to="/demo">
            Try the live demo
          </Button>
          <Button variant="outlined" component={RouterLink} to="/pricing">
            See pricing
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFound;
